import { render, staticRenderFns } from "./BlockEditDes.vue?vue&type=template&id=cef2d064&"
import script from "./BlockEditDes.vue?vue&type=script&lang=js&"
export * from "./BlockEditDes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports